import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
// import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import { connect, ReduxState } from 'kts-platform-frame/redux';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'src/node_modules/kts-platform-frame/routes';
import AppCard from 'src/display/components/AppCard';
import { IBtn } from 'src/display/components/AppCard';
import { mediaUrl } from 'kts-platform-frame/entry/configUtils';
import { create } from 'kts-scaffold-framework/utils/form';
import { Button, Checkbox, Modal } from 'antd';
import IcoCaveat from './img.caveat';

const css = require('./index.scss');
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    private groupBtns(appInfo: any) {
        const btns: Array<IBtn> = [
            {
                place: 'right',
                btnName: '详情',
                onClick: () => { ModulesAction.openDrawerDetail(appInfo); },
            }];
        if (appInfo.isActivated === 1) {
            btns.push({
                place: 'left',
                btnName: '禁用',
                onClick: () => { ModulesAction.prohibit(appInfo); },
            });
            if (appInfo.appType !== 1) {
                btns.push({
                    place: 'left',
                    btnName: '设置权限',
                    onClick: () => { ModulesAction.openDrawerSetPower(appInfo); },
                });
            }
        } else {
            btns.push({
                place: 'left',
                btnName: '激活',
                onClick: () => { ModulesAction.isActivate(appInfo); },
            });
        }
        return btns;
    }
    render() {
        const imgHost = mediaUrl();
        const isReadCheckd = this.modulesState.isReadCheckd;
        return (
            <div className={css.carouselbox} ref={dom => this.modulesState.carouselboxContent = dom}>
                {
                    this.modulesState.appList && this.modulesState.appList.length > 0 ?
                    <div >
                            {
                                this.modulesState.appList.map((value, index) => {
                                    return (
                                        <AppCard
                                            key={index}
                                            className={css.appItem}
                                            title={value.appName}
                                            subject={value.appIntroduction}
                                            icon={value.appIcon ? `${imgHost}${value.appIcon}` : null}
                                            isShowStatus={true}
                                            status={!!value.isActivated}
                                            secondName={value.categoryName}
                                            onClick={() => { (value.appType !== 1 && value.isActivated === 1) ? ModulesAction.openApp(value) : null ;  }}
                                            buttonGroup={this.groupBtns(value)}
                                        />
                                    );
                                })
                            }
                        </div> :
                        (
                            <div className={css.noData} >
                                <p><i dangerouslySetInnerHTML={{ __html: IcoCaveat }} /></p>
                                <p>暂无应用</p>
                            </div>
                        )
                }
                {
                    this.modulesState.activTipsM &&
                    <Modal
                        title={null}
                        visible={this.modulesState.activTipsM}
                        width={'700px'}
                        footer={null}
                        className={css.infoTipsM}
                        bodyStyle={{ height: '550px' }}
                        onCancel={() => {
                            ModulesAction.activeTipsM(false);
                        }}
                    >
                        <div className={css.infoTipsContent}>
                            <div className={css.infoTipsMTitle}>激活提示</div>
                            <div className={css.infoTipsMContent}>
                                接受许可协议以激活。{
                                    this.modulesState.appCategories.map(item => {
                                        return (<span key={item.apiCategoryId}>&nbsp;/&nbsp; 该应用会访问{item.apiCategoryName}</span>);
                                    })
                                }
                            </div>
                            <div className={css.infoTipsMTitle}>用户协议</div>
                            <div className={css.infoTipsMContent}>
                                <div dangerouslySetInnerHTML={{ __html: this.modulesState.appAgreementContent }} />
                            </div>
                        </div>
                        <div className={css.infoTipsFooter}>
                            <div className={css.infoTipsFooterCheck}>
                                <Checkbox value={isReadCheckd} onChange={ModulesAction.onChangeCheck}>
                                    <span className={css.readAgree}>我已阅读并同意</span>
                                </Checkbox>
                            </div>
                            <div className={css.infoTipsFooterSubmit}>
                                <Button type="link" disabled={!isReadCheckd} onClick={() => ModulesAction.appInstanceActivate(this.modulesState.appInfo.appId)} className={css.footerBts}>
                                    确定
                                </Button>
                                <Button type="link" className={css.footerBts} onClick={() => ModulesAction.activeTipsM(false)}>
                                    取消
                                </Button>
                            </div>
                        </div>
                    </Modal>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/UI.List.tsx